module.exports = __webpack_public_path__ + "fb6984f953f6ff1ace966b913ced3391.png";